import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BioModal.module.scss";
import { messages } from "../CreativeProcess.messages";
import { useUi } from "@jelly/lesson";

type MichaelBioModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const MichaelBioModal: React.FC<MichaelBioModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  let linkToPresent = "placeholder-link";
  try {
    const url = new URL(formatMessage(messages.bioMichaelLink));
    linkToPresent = url.host;
  } catch {
    // ...
  }

  return (
    <ui.Modal {...props} title={formatMessage(messages.bioMichaelTitle)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.bioMichaelDescription)}</div>
        <div className={styles.link}>
          <ui.Button
            size="small"
            shape={"normal"}
            theme={"primary"}
            onClick={() => window.open(formatMessage(messages.bioMichaelLink))}
          >
            {linkToPresent}
          </ui.Button>
        </div>
      </div>
    </ui.Modal>
  );
};

//TODO: override scrollbars colors
